import { Can } from "@/casl-provider";
import { buildVehicleBuyInSearchBody } from "@/common/helpers/build-vehicle-buy-in-search-body";
import { VehicleBuyInTable } from "@/components/data-table/predefined/vehicle-buy-in-table/vehicle-buy-in-table";
import { BranchFilter } from "@/components/filter/predefined/branch-filter";
import { CompanyFilter } from "@/components/filter/predefined/company-filter";
import { CompanyGroupFilter } from "@/components/filter/predefined/company-group-filter";
import { VehicleBuyInEmployeeFilter } from "@/components/filter/predefined/vehicle-buy-in-employee-filter";
import { VehicleBuyInSignatureDeviceFilter } from "@/components/filter/predefined/vehicle-buy-in-signature-device-filter";
import { VehicleBuyInStatusFilter } from "@/components/filter/predefined/vehicle-buy-in-status-filter";
import { VehicleBuyInTypeFilter } from "@/components/filter/predefined/vehicle-buy-in-type-filter";
import { VehicleValuationCreatedAtRangeFilter } from "@/components/filter/predefined/vehicle-valuation-created-at-range-filter";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { userConfigStore } from "@/store/user-config-store";
import { HandCoinsIcon } from "lucide-react";
import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

const DEFAULT_FILTER_VALUES: Record<string, string[]> = {
  status: [],
  type: [],
  signatureDevice: [],
  companyGroup: [],
  company: [],
  branch: [],
  createdBy: [],
  createdAt: [],
};

export function VehicleBuyInListView() {
  const { t } = useTranslation("fab");
  const dateFormat = userConfigStore((state) => state.dateFormat);
  const [filterValues, setFilterValues] = useState(DEFAULT_FILTER_VALUES);
  const filters = useMemo(
    () => [
      new VehicleBuyInStatusFilter(),
      new VehicleBuyInTypeFilter(),
      new VehicleBuyInSignatureDeviceFilter(),
      new CompanyGroupFilter(),
      new CompanyFilter({ id: "company" }),
      new BranchFilter({ id: "branch" }),
      new VehicleBuyInEmployeeFilter(),
      new VehicleValuationCreatedAtRangeFilter(),
    ],
    [],
  );
  const body = useMemo(() => buildVehicleBuyInSearchBody({ filterValues, dateFormat }), [dateFormat, filterValues]);
  const handleFilterChange = useCallback((filterId: string, values: string[]) => {
    setFilterValues((currentValues) => ({ ...currentValues, [filterId]: values }));
  }, []);

  return (
    <Can I="read" a="VehicleBuyIn">
      <CenteredLayout
        variant={CenteredLayoutVariant.Table}
        title={t("VehicleBuyIns")}
        subTitle={t("VehicleBuyInsDescription")}
      >
        <VehicleBuyInTable
          body={body}
          filters={filters}
          filterValues={filterValues}
          filterContainerClassName="w-96"
          onFilterChange={handleFilterChange}
          queryOptions={{ refetchInterval: 10_000 }}
          noDataTitle={t("NoVehicleBuyIns")}
          noDataDescription={t("NoVehicleBuyInsDescription")}
          noDataIcon={HandCoinsIcon}
        />
      </CenteredLayout>
    </Can>
  );
}
